<template>
  <Container>
    <template #title>Create your brand profile</template>
    <template #subtitle>Tell us about your brand</template>
    <template #form>
      <form class="form p-fluid" @submit.prevent="submit">
        <BrandProfileForm v-model="brand" :getError="getError" />
        <div class="form-buttons">
          <Button label="Next Step" class="p-button-md" @click="submit" :loading="busy" />
        </div>
      </form>
    </template>
  </Container>
</template>

<script setup>
import FormField from "../../../components/FormField";
import {useForm} from "../../../hooks/useForm";
import {computed, onMounted, reactive, ref, watch} from "vue";
import Container from "./Container";
import {useBrand} from "../../../hooks/useBrand";
import {useRouter} from "vue-router";
import {useStore} from "vuex";
import {useFile} from "../../../hooks/useFile";
import BrandProfileForm from "../../../components/forms/BrandProfileForm";

const emit = defineEmits(['onNext', 'onPrev']);

const store = useStore();
const router = useRouter();
const {registerNewBrand, current} = useBrand();

const step = ref(1);
const user = computed(() => store.getters['auth/user']);
const brand = reactive({});

watch(() => user, async () => await loadCurrentBrandIfNeed())

onMounted(async () => await loadCurrentBrandIfNeed());

const {busy, submit, getError} = useForm(async () => {
  const data = {...brand};

  if (!(data.logo instanceof File)) {
    delete data.logo;
  }

  await registerNewBrand(data);
  emit('onNext');
});

const loadCurrentBrandIfNeed = async () => {
  if (user.value.current_brand_id) {
    Object.assign(brand, (await current()).data);
  }
}

</script>

<style lang="scss" scoped>
@import "../../../assets/sass/theme_variables";

.form-buttons {
  margin-top: toRem(24);
}

.note {
  margin-top: toRem(10);
  font-size: toRem(12);
  color: $textThirdColor;

  a {
    color: $textThirdColor;
  }
}

.to-login {
  margin-top: toRem(16);
}
</style>
